import { render, staticRenderFns } from "./CritereProduit.vue?vue&type=template&id=6a51cbe5"
import script from "./CritereProduit.vue?vue&type=script&lang=js"
export * from "./CritereProduit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports